import CurrentChampionshipContacts from '../champion-to-close/CurrentChampionshipContacts.jsx'
import styles from './ChampionshipDrawer.module.css'

export default function OpportunityContact({ record }) {
  return <section className={styles.contact} aria-label="Championship contact review">
    <span className="eyebrow">Historical championship coach</span>
    {record?.story?.coach ? <strong>{record.story.coach}</strong>
      : <p>Historical championship coach not recorded. This does not establish current contact availability.</p>}
    <small>Championship source fact, not a selected outreach recipient.</small>
    <CurrentChampionshipContacts record={record}/>
  </section>
}
